import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import ActionTile from 'components/common/proposal/ActionTile';
import styled from 'styled-components';

export const WrapperStyled = styled.section`
  background-color: ${colors.neutral.white};
  padding: 5rem 10rem;
  border-radius: 1rem;
  position: relative;
  min-height: 50rem;
  box-sizing: border-box;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const ActionListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 3rem 0 10.5rem;
  display: flex;
  justify-content: flex-start;
  gap: 2rem;

  @media (width < 860px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 4rem;
    gap: 3rem;
  }
`;

export const ActionButtonStyled = styled(Button)`
  @media (width < 860px) {
    min-width: 25rem;
  }
`;

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  gap: 2rem;

  @media (width < 860px) {
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
  }
`;

export const ActionTileStyled = styled(ActionTile)`
  @media (width < 860px) {
    max-width: 25rem;
  }

  ${breakpointsMQ4.sm.down} {
    width: 100%;
    max-width: unset;
  }
`;
